// BlogPostCard.js
import React from "react";
import { Link } from "react-router-dom";
import "./BlogPostCard.css";

const BlogPostCard = ({ post, isPreview = false }) => {
  const formattedDate = new Date(post.createdAt).toLocaleDateString();

  return (
    <div className={`blog-post-card ${isPreview ? "preview" : ""}`}>
      {isPreview && <div className="preview-badge">Preview</div>}

      {post.featuredImage && (
        <div className="post-image">
          <img
            src={
              post.featuredImage.startsWith("http://") ||
              post.featuredImage.startsWith("https://")
                ? post.featuredImage
                : `${process.env.REACT_APP_SERVER_BASE_URL}${post.featuredImage}`
            }
          />
        </div>
      )}

      <div className="post-content">
        <h2 className="post-title">
          {isPreview ? (
            post.title
          ) : (
            <Link to={`/blog/${post.slug}`}>{post.title}</Link>
          )}
        </h2>

        <div className="post-meta">
          <div className="author-info">
            <img
              src={post.author.profilePicture || "/images/default-avatar.png"}
              alt={`${post.author.firstName} ${post.author.lastName}`}
              className="author-avatar"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/images/default-avatar.png";
              }}
            />
            <span className="post-author">
              By: {post.author.firstName} {post.author.lastName}
            </span>
          </div>
          <span className="post-date">{formattedDate}</span>
          {post.category && (
            <span className="post-category">{post.category}</span>
          )}
        </div>

        <div className="post-excerpt">
          {isPreview ? post.publicExcerpt || post.excerpt : post.excerpt}
        </div>

        {post.tags && post.tags.length > 0 && (
          <div className="post-tags">
            {post.tags.map((tag) => (
              <span key={tag} className="tag">
                {tag}
              </span>
            ))}
          </div>
        )}

        {isPreview ? (
          <div className="post-cta">
            <Link to="/register" className="cta-button">
              Create Account to Read More
            </Link>
          </div>
        ) : (
          <div className="post-read-more">
            <Link to={`/blog/${post.slug}`}>Read More</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogPostCard;
